import React, { useState } from "react";
import ButtonPrimary from "../components/Button-primary";
import ButtonSecondary from "../components/Button-secondary";
import { copyToClipboard } from '../utils/clipboard';
const { ethers } = require("ethers");

const PrivateKey = () => {
  const [privateKey, setPrivateKey] = useState("");
  const [warning, setWarning] = useState(true);

  const generatePrivateKey = () => {
    const wallet = ethers.Wallet.createRandom();
    const newPrivateKey = wallet.privateKey;
    setPrivateKey(newPrivateKey);
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(privateKey);
      const copiedClass = document.querySelector(".copied-class");
      copiedClass.classList.remove("hidden");
      setTimeout(() => {
        copiedClass.classList.add("hidden");
      }, 5000);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  const closeWarning = () => {
    setWarning(false);
  };

  return (
    <>
      <div
        className={`mt-4 mx-4 px-4 rounded-md border-l-4 border-red-500 bg-red-50 ${
          warning ? "flex" : "hidden"
        } md:max-w-2xl md:mx-auto md:px-8 mb-4`}
      >
        <div className="flex justify-between py-3">
          <div className="flex">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6 text-red-500"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <div className="self-center ml-3">
              <span className="font-semibold text-red-600">Warning</span>
              <p className="mt-1 text-red-600">
                We don't store the private key. But for your safety, don't use
                this tool to generate a private key for your main wallet.
              </p>
            </div>
          </div>
          <ButtonPrimary
            text={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            }
            func={closeWarning}
            className={"bg-transparent shadow-none text-red-500 py-0 px-0"}
          />
        </div>
      </div>

      <div
          className={`mt-4 mx-4 px-4 absolute top-10 right-5 z-[300] rounded-md border-l-4 border-green-500 bg-green-50 w-fit md:mx-auto md:px-8 mb-4 copied-class hidden transition-all duration-500`}
      >
        <div className="flex justify-between py-3">
          <div className="flex">
            <div className="self-center ml-3">
              <p className="mt-1 text-green-600">Copied to Clipboard</p>
            </div>
          </div>
        </div>
      </div>
      <div className="w-[90%] md:w-1/2 m-auto flex flex-col gap-y-2 items-center">
        <p
          className="w-full px-4 py-2 mt-4 text-gray-500 border rounded-lg"
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {privateKey ? privateKey : "Private key"}
        </p>
        <div className="flex flex-col items-center justify-center w-full gap-4 mt-4 md:flex-row">
          <ButtonPrimary
            text={"Generate Private Key"}
            func={generatePrivateKey}
          />
          <ButtonSecondary text={"Copy to Clipboard"} func={() => privateKey && copyToClipboard(privateKey)}/>
        </div>
      </div>
    </>
  );
};

export default PrivateKey;
